var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('th',[_vm._v("Culturetest")]),_c('th',[_vm._v("Culturedate")]),_c('th',[_vm._v("Cultureres")])])}
var staticRenderFns = []

export { render, staticRenderFns }